// extracted by mini-css-extract-plugin
export var content = "StoryCard-module--content--3472d";
export var cta = "StoryCard-module--cta--e4d1b";
export var image = "StoryCard-module--image--0a60b";
export var image_wrapper = "StoryCard-module--image_wrapper--e875f";
export var label = "StoryCard-module--label--38afa";
export var link_overlay = "StoryCard-module--link_overlay--4c8f8";
export var title = "StoryCard-module--title--61fcb";
export var wrapper = "StoryCard-module--wrapper--127e2";